import React from "react";
import { SelectInput, useGetList } from "react-admin";

const PLACES_PAGINATION = { page: 1, perPage: 25 };
const PLACES_SORT = { field: "id", order: "DESC" };

export const PlaceSelectInput = ({ terminalId, ...props }) => {
	const filter = React.useMemo(
		() => ({
			terminal_id: [terminalId],
			disabled: false,
			is_deleted: false,
			no_range: true,
			is_preparation: true,
		}),
		[terminalId]
	);
	const { data, ids } = useGetList("areas", PLACES_PAGINATION, PLACES_SORT, filter);
	const choices = React.useMemo(
		() => (ids || []).map((id) => data[id]).filter(Boolean),
		[ids, data]
	);

	return (
		<SelectInput
			allowEmpty
			emptyValue=""
			optionText="name"
			disableValue="disabled_by_any"
			{...props}
			choices={choices}
		/>
	);
};
